// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__i-PZg","right":"styles_right__2ficy"};